<template>
  <div v-show="isActive">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'FormWizardTab',

  props: {
    name: {
      default: '',
    },
    desc: {},
    type: {
      default: 'tab',
    },
    selected: {
      default: false,
    },
    done: {
      default: false,
    },
    validate: {
      type: Function,
      default: null,
    },
    submit: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      isActive: false,
      isDone: false,
    };
  },
  created() {
    this.isActive = this.selected;
    this.isDone = this.done;
  },
};
</script>
